import React from 'react';
import { IconBase } from '../Base';
export const IconChevronUpLarge = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M16 12.75L9.99267 7.25L4 12.75", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=UpLarge.js.map